<template lang="pug">
  ul.mt0.list-reset.primary-list
    li.list-item.flex.my2(v-for="item, idx in data", :key="item.id")
      .primary-img.col-4.overflow-hidden(data-ratio="16/9")
        a(:href="item.origin_url", target="_blank")
          img.fit(v-lazy="shift(item.o_pic_list[0])")
      .primary-info.col-8.px2.pb2.flex.flex-column.items-start.justify-between
        a(:href="item.origin_url", target="_blank")
          .mt0.mb1.item-title(:title="item.title", data-clamp="3") {{ item.title }}
        p(data-clamp="3").
          {{ item.summary }}
        .sub.col-12
          | {{ item.pub_source }}
          span.px1 |
          | {{ formatUtc(item.pub_utc) }}
</template>

<script>
import moment from "moment";

import transformImgLink from "@/assets/utils/transformImgLink";
export default {
  props: ["data"],
  methods: {
    shift(link) {
      return transformImgLink(link);
    },
    formatUtc(utc) {
      return moment.unix(utc).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl'
.primary-img
  img
    width 100%
    transform scale(1.3)
    transition-duration 1s
    transition transform .3s ease-out
  &:hover
    img
      transform scale(1.5)
      transition-duration .8
.primary-info
  height 180px
</style>



// WEBPACK FOOTER //
// DetailList.vue?1e5c40c8